import { atom } from 'recoil';
import { SupportedLanguages } from 'models/languages';

export const languageAtom = atom<SupportedLanguages>({
  key: 'language',
  default: 'ko',
});
